function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
export var RETRIEVE_OFFERING_OFFER_REMOVAL_CONTEXT = {
  BEGIN: 'RETRIEVE_OFFERING_OFFER_REMOVAL_CONTEXT_BEGIN',
  SUCCESS: 'RETRIEVE_OFFERING_OFFER_REMOVAL_CONTEXT_SUCCESS',
  FAILURE: 'RETRIEVE_OFFERING_OFFER_REMOVAL_CONTEXT_FAILURE'
};
var RETRIEVE_OFFERING_OFFER_REMOVAL_CONTEXT_TYPES = [RETRIEVE_OFFERING_OFFER_REMOVAL_CONTEXT.BEGIN, RETRIEVE_OFFERING_OFFER_REMOVAL_CONTEXT.SUCCESS, RETRIEVE_OFFERING_OFFER_REMOVAL_CONTEXT.FAILURE];
export var CALCULATE_COS_ORDER_QUOTE = {
  BEGIN: 'CALCULATE_COS_ORDER_QUOTE_BEGIN',
  SUCCESS: 'CALCULATE_COS_ORDER_QUOTE_SUCCESS',
  FAILURE: 'CALCULATE_COS_ORDER_QUOTE_FAILURE'
};
var CALCULATE_COS_ORDER_QUOTE_TYPES = [CALCULATE_COS_ORDER_QUOTE.BEGIN, CALCULATE_COS_ORDER_QUOTE.SUCCESS, CALCULATE_COS_ORDER_QUOTE.FAILURE];
export var CHANGE_OF_SERVICE_ORDER_REMOVAL = {
  BEGIN: 'CHANGE_OF_SERVICE_ORDER_REMOVAL_BEGIN',
  SUCCESS: 'CHANGE_OF_SERVICE_ORDER_REMOVAL_SUCCESS',
  FAILURE: 'CHANGE_OF_SERVICE_ORDER_REMOVAL_FAILURE'
};
var CHANGE_OF_SERVICE_ORDER_REMOVAL_TYPES = [CHANGE_OF_SERVICE_ORDER_REMOVAL.BEGIN, CHANGE_OF_SERVICE_ORDER_REMOVAL.SUCCESS, CHANGE_OF_SERVICE_ORDER_REMOVAL.FAILURE];
export var retrieveOfferingRemovalContext = function retrieveOfferingRemovalContext(requestData, subscriberId) {
  return function (dispatch) {
    return retrieveOfferingRemovalContextPromise(dispatch, requestData, subscriberId);
  };
};
export var retrieveOfferingRemovalContextPromise = function retrieveOfferingRemovalContextPromise(dispatch, requestData, subscriberId) {
  return ThunkHelper(dispatch, RETRIEVE_OFFERING_OFFER_REMOVAL_CONTEXT_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOfferingContext',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
    data: requestData
  });
};
export var calculateChangeOfServiceQuote = function calculateChangeOfServiceQuote(requestData, subscriberId) {
  return function (dispatch) {
    return calculateChangeOfServiceQuotePromise(dispatch, requestData, subscriberId);
  };
};

/*
    Note: For `calculateChangeOfServiceOrderQuote` API if there is an offering id
the API will asusme it's a remove offer. If there's no offeringId, the API
will assume the request is a disconnect and go through validation that checks
whether there's any offers in the pending-removal state. If there are offers in
pending-removal state, the API will throw an error.
*/
export var calculateChangeOfServiceQuotePromise = function calculateChangeOfServiceQuotePromise(dispatch, requestData, subscriberId) {
  return ThunkHelper(dispatch, CALCULATE_COS_ORDER_QUOTE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/CalculateChangeOfServiceOrderQuote',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
    data: requestData
  });
};
export var submitChangeOfServiceOrderRemoval = function submitChangeOfServiceOrderRemoval(request, subscriberId) {
  return function (dispatch) {
    return submitChangeOfServiceOrderRemovalPromise(dispatch, request, subscriberId);
  };
};

/*
    Note: For `submitChangeOfServiceOrderRemoval` API if there is an offering id
the API will asusme it's a remove offer. If there's no offeringId, the API
will assume the request is a disconnect and go through validation that checks
whether there's any offers in the pending-removal state. If there are offers in
pending-removal state, the API will throw an error.
*/

export var submitChangeOfServiceOrderRemovalPromise = function submitChangeOfServiceOrderRemovalPromise(dispatch, request, subscriberId) {
  return ThunkHelper(dispatch, CHANGE_OF_SERVICE_ORDER_REMOVAL_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/SubmitChangeOfServiceOrder',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
    data: request
  });
};